import { Header } from '@/components/Header';
import { ManageRoles } from '@/pages/ManageRoles';
import type { ManageRolesSearch } from '@/lib/types/roles.types';
import {
  createFileRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-roles'
)({
  validateSearch: (search): ManageRolesSearch => ({
    deletedRole:
      typeof search.deletedRole === 'string' ? search.deletedRole : undefined,
  }),
  component: ManageRolesPage,
});

function ManageRolesPage() {
  const { deletedRole } = Route.useSearch();
  const router = useRouterState();
  const isChildRoute = router.matches.some(
    (match) =>
      match.routeId === '/_authenticated/_admin/admin/manage-roles/$roleId' ||
      match.routeId ===
        '/_authenticated/_admin/admin/manage-roles/$roleId/edit' ||
      match.routeId === '/_authenticated/_admin/admin/manage-roles/new'
  );

  if (isChildRoute) {
    return <Outlet />;
  }

  return (
    <>
      <Header enableBack additionalClasses="bg-slate-700" />
      <ManageRoles deletedRoleName={deletedRole} />
    </>
  );
}
